import {SearchmorePage} from './searchmore/searchmore';
import {SearchPage} from './search/search';
import {MessagedetailPage} from './messagedetail/messagedetail';
import {SingleSearchPage} from './singlesearch/singlesearch';

export const COMMON_SERARCH_INDEX = [
  SearchmorePage,
  SearchPage,
  MessagedetailPage,
  SingleSearchPage
];


// WEBPACK FOOTER //
// ./src/pages/commonsearch/index.ts